'use es6';

import { addControls } from './controls';
export function initContentGenerationSelectionPlugin(editor, selectionCommands, brandVoiceOptions) {
  if (!selectionCommands.length) return;
  addControls(editor, selectionCommands, brandVoiceOptions);
}